import styled from "styled-components";

import { Tabs } from "@libraries/mui";

const StepsContainer = styled(Tabs)`
  min-height: 35px !important;
  width: 100% !important;
  overflow: hidden !important;

  .MuiTabs-scrollButtons.Mui-disabled {
    opacity: 0.3;
  }

  .MuiTabs-scroller {
    .MuiTabs-flexContainer {
      gap: 20px !important;

      > :not(.Mui-selected) {
        opacity: 85% !important;
      }

      > .Mui-selected {
        background-color: ${(props) => props.theme.colors.primary} !important;
      }
    }

    .MuiTabs-indicator {
      display: none;
    }
  }
`;

const ControlButtons = styled.div`
  position: fixed;
  right: 16px;
  bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;

  .MuiFab-primary {
    background-color: ${(props) => props.theme.colors.primary} !important;
  }

  .MuiFab-success {
    background-color: ${(props) => props.theme.colors.success} !important;
  }

  .MuiFab-sizeLarge {
    width: 80px !important;
    height: 80px !important;
  }

  .MuiFab-sizeMedium {
    width: 60px !important;
    height: 60px !important;
  }
`;

export { StepsContainer, ControlButtons };
